<!-- Hero Banner Starts-->
<section class="aboutus-sec">
  <div class="container-fluid">
    <div class="row">
      <div class="col-xs-12 col-md-12  no-pad">
        <img src="assets/img/herobanner.png" alt="" class="abouthero">
        <!-- <div class="col-md-7 col-xs-12 no-pad">
                      <img src="assets/img/abouthero.png" alt="" class="abouthero">
                  </div>
                  <div class="col-md-5 col-xs-12">
                      <div class="aboutus-img">
                          <img src="assets/img/aboutus.png" alt="">
                          <div class="text-on-img">
                              <p>"We transform the Digital Learning experience for the teacher & child by combining traditional wisdom and world class
                                  e-learning platform that is progressive and engaging."</p>
                          </div>
                      </div>
                  </div> -->
      </div>
    </div>
  </div>
</section>
<!-- Hero Banner Ends-->
<!-- Our Management Section Starts -->
<section class="management-sec">
  <div class="container-fluid">
    <div class="row">
      <div class="col-12">
        <div class="sec-title">
          <h2>Our <span>Management</span></h2>
          <!-- <div class="digital-team">
            <a href="team.html" target="_blank">Meet Our Digital Talent</a>
          </div> -->
        </div>
        <!-- <div class="col-xs-12 col-md-12 "> -->
        <div class="row">
          <div class="col-xs-12 col-md-3">
            <div class="man-one">
              <img src="assets/img/ujjwal-img.png" alt="">
              <h4>Ujjwal Singh</h4>
              <p>CEO</p>
            </div>
            <div class="team-text">
              <p>A Tedx Speaker, Education Futurist and more than 20 years of industry experience, an alumnus of IIM Bangalore, Ujjwal
                has build digital capabilities and scaled innovation globally. Prior to this, worked as a Vice President, Global
                Product Organisation at Pearson PLC and also held senior positions in organizations such as Indus-Balaji Private
                Equity (Education) Fund, iDiscoveri Education (XSEED), Hughes Communications, NIIT Ltd and Tata Infotech. He has an avid interest in exploring ‘progressive Learning’ through the medium of technology interfaces and his deep desire to shape the future of Education.

              </p>
            </div>
          </div>
          <div class="col-xs-12 col-md-3 ">
            <div class="man-one">
              <img src="assets/img/sridhar.png" alt="">
              <h4>Sridhar Yalamanchili</h4>
              <p>Co-founder</p>
            </div>
            <div class="team-text">
              <p>Mr. Sridhar did his Bachelor’s in Engineering from Wayne State University and Master’s from Northern
                State
                University, USA. He has over 10 years of experience in Financial and IT sectors. He looks after
                administration,
                finance, and IT application in the Institution. His vast experience and leadership are pivotal in the
                digitally
                enhanced teaching and learning experience at Infinity Learn.</p>
            </div>
          </div>
          <div class="col-xs-12 col-md-3 ">
            <div class="man-one">
              <img src="assets/img/sushma.png" alt="">
              <h4>Sushma Boppana</h4>
              <p>Co-founder</p>
            </div>
            <div class="team-text">
              <p>A Sri Chaitanya Alumnus herself, Sushma took over as its chief of academic planning in the year 2007.
                As
                the Academic
                Director of Sri Chaitanya colleges, Sushma is committed to redefine learning and shift the focus from
                ‘academics
                alone’ to the holistic development of children, enriched with multifaceted learning experiences that
                foster
                creativity. Sushma is a devoted educator who enjoys being with children, guiding the parents, and
                inspiring faculty.
              </p>
            </div>
          </div>
          <div class="col-xs-12 col-md-3 ">
            <div class="man-one">
              <img src="assets/img/seema.png" alt="">
              <h4>Seema Boppana</h4>
              <p>Co-founder</p>
            </div>
            <div class="team-text">
              <p>Seema Boppana graduated with a Bachelor’s Degree in Science majoring in Management and marketing. Ms.
                Seema Boppana
                gained her initial work experience as Administrative Director of Sri Chaitanya Educational Institutions
                from 2008,
                she translated the dream of Sri Chaitanya Techno Schools into reality. She designed the school
                curriculum
                with
                academic experts and ed-tech veterans from the IITs and the NITs.</p>
            </div>
          </div>
        </div>
        <!-- </div> -->
      </div>
    </div>
  </div>
</section>
<!-- Our Management Section Ends -->
<!-- Our Story Section Starts -->
<section class="story-sec">
  <div class="container-fluid">
    <div class="row">
      <div class="col-xs-12 col-md-12  ">
        <div class="story-title">
          <h2>Our <span>Story</span></h2>
        </div>
        <div class="story-center">
          <div class="col-md-4 col-xs-12">
            <div class="story-img">
              <img src="assets/img/srichaitanyalogo.png" alt="">
            </div>
          </div>
          <div class="col-md-8 col-xs-12">
            <div class="story-text">
              <p>Infinity Learn is a protege of Asia’s leading educational group Sri Chaitanya (renowned educational
                institute for
                three decades). We are led by people with the purpose to become global leaders in the digital learning
                arena. Our
                vision is to carry forward our legacy in the digital learning and teaching space and create a powerful
                impact in
                every child’s life.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<!-- Our Story Section Ends -->
<!-- Our Credentials Section Starts -->
<section class="credential-sec">
  <div class="container-fluid">
    <div class="row">
      <div class="col-xs-12 col-md-12 ">
        <div class="cred-title">
          <h2>Our <span>Credentials</span></h2>
        </div>
        <div class="row">
          <div class="col-xs-12 col-md-6">
            <div class="cred-one">
              <img src="assets/img/Photoonee.png" alt="">
              <h3>Startup India certificate</h3>
              <p>Lifetime achievement in Education Leadership</p>
            </div>
          </div>
          <div class="col-xs-12 col-md-3">
            <div class="cred-two">
              <img src="assets/img/Phototwo.png" alt="">
              <h3>Education World</h3>
              <p>Lifetime achievement in Education Leadership</p>
            </div>
          </div>
          <div class=" col-xs-12 col-md-3 ">
            <div class="cred-three">
              <img src="assets/img/Photothree.png" alt="">
              <h3>Asia One</h3>
              <p>Asia's Greatest Brands 2017</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<!-- Our Credentials Section Ends -->

<!-- Footer Start -->
<app-footer></app-footer>
<!-- Footer End -->